import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Production mode'da console.log'ları kapat
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);